// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"Request_subTitle__1Gawx","modalLabel":"Request_modalLabel__2i2QH","modalLabelC":"Request_modalLabelC__1VAJZ","modalContentC":"Request_modalContentC__2Zu4S"};